// Habits (doc/feature/habits.md): a person's habits, checked off per day in the calendar's
// day and week views and in Next up. Days are `YYYY-MM-DD` on the person's clock; the server says
// which day is today there (`planner/habits` `today`) and refuses later days.

/**
 * The icons a habit may take, in the order the dialog offers them. The server checks the same
 * list (`planner::habits::ICONS`, whose test reads this file); each is written out as an `icon`
 * key with its name quoted, so `bun run icons` bundles it.
 */
export const HABIT_ICONS = [
  { icon: 'check-circle', label: 'Check' },
  { icon: 'barbell', label: 'Workout' },
  { icon: 'person-simple-run', label: 'Run' },
  { icon: 'bicycle', label: 'Ride' },
  { icon: 'book-open', label: 'Read' },
  { icon: 'drop', label: 'Water' },
  { icon: 'bed', label: 'Sleep' },
  { icon: 'sun', label: 'Outside' },
  { icon: 'leaf', label: 'Green' },
  { icon: 'pill', label: 'Medicine' },
  { icon: 'heartbeat', label: 'Health' },
  { icon: 'brain', label: 'Learn' },
  { icon: 'pen-nib', label: 'Write' },
  { icon: 'music-notes', label: 'Music' },
  { icon: 'coffee', label: 'Coffee' },
  { icon: 'carrot', label: 'Eat well' },
  { icon: 'flower-lotus', label: 'Meditate' },
  { icon: 'translate', label: 'Language' },
  { icon: 'code', label: 'Code' },
  { icon: 'broom', label: 'Tidy' },
  { icon: 'tooth', label: 'Floss' },
  { icon: 'phone-slash', label: 'No phone' },
  { icon: 'money', label: 'Save' },
  { icon: 'plant', label: 'Plants' },
]

/** The colors of the calendar palette (`--color-avatar-N`). */
export const HABIT_COLORS = [1, 2, 3, 4, 5, 6, 7, 8]

/** "5 days in a row", '' under two. */
export function streakText(streak) {
  return streak > 1 ? `${streak} days in a row` : ''
}

/**
 * The chips of one day: each habit with whether it was done that day, and whether the day is
 * after `today` (it cannot be checked yet).
 */
export function habitChips(habits, day, today) {
  return (habits || []).map((habit) => {
    const done = habit.days.includes(day)
    const later = day > today
    const streak = day === today ? streakText(habit.streak) : ''
    return {
      ref: habit.ref,
      name: habit.name,
      icon: habit.icon,
      color: habit.color,
      done,
      later,
      title: [habit.name, later ? 'not yet' : done ? 'done' : 'not done', streak].filter(Boolean).join(', '),
    }
  })
}

/**
 * The habits after checking (`done`) or unchecking one on a day, before the server answers:
 * the day joins or leaves its `days`, and `streak` comes from the answer (`planner/habit_check`)
 * when given.
 */
export function checkHabit(habits, ref, day, done, streak) {
  return habits.map((habit) => {
    if (habit.ref !== ref) return habit
    const days = habit.days.filter((entry) => entry !== day)
    if (done) days.push(day)
    days.sort()
    return { ...habit, days, streak: streak ?? habit.streak }
  })
}
